import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../apiConfig';
import { getTenantHeaders } from '../../config/tenant';
import { Course } from '../../types/course';
import SuggestedCoursesCarousel from './SuggestedCoursesCarousel';

interface SuggestedCoursesSectionProps {
  id?: string;
  className?: string;
}

const SuggestedCoursesSection: React.FC<SuggestedCoursesSectionProps> = ({
  id = 'suggested-courses-section',
  className = 'relative scroll-mt-24 py-14 sm:py-20 lg:py-24',
}) => {
  const [recommendedCourses, setRecommendedCourses] = useState<Course[]>([]);
  const [loadingCourses, setLoadingCourses] = useState(false);

  useEffect(() => {
    const fetchRecommendedCourses = async () => {
      try {
        setLoadingCourses(true);
        const response = await axios.get<{
          success: boolean;
          message?: string;
          data?: {
            data: Course[];
          };
        }>(`${BASE_URL}api/Course/suggested`, {
          params: { pageNumber: 1, pageSize: 6 },
          headers: { ...getTenantHeaders() },
        });

        if (response.data?.success && response.data?.data?.data) {
          setRecommendedCourses(response.data.data.data);
        }
      } catch (error) {
        console.error('Error fetching recommended courses:', error);
      } finally {
        setLoadingCourses(false);
      }
    };

    fetchRecommendedCourses();
  }, []);

  return (
    <section id={id} className={className}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-8 max-w-2xl sm:mb-10 lg:mb-12">
          <div className="mb-3 flex items-center gap-2.5">
            <span className="inline-block h-5 w-1 shrink-0 rounded-full bg-gold-500" aria-hidden />
            <p className="text-sm font-semibold text-gold-700">مختاراتنا ليك</p>
          </div>
          <h2 className="font-thmanyah text-[clamp(2rem,4.5vw,3.75rem)] font-bold leading-[1.12] text-green-800">
            كورسات هتفرق معاك
          </h2>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-green-900/70 sm:text-base">
            أهم الحصص والكورسات مجمّعة في مكان واحد
          </p>
        </div>

        <SuggestedCoursesCarousel courses={recommendedCourses} loading={loadingCourses} />
      </div>
    </section>
  );
};

export default SuggestedCoursesSection;
